"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const cw_http_service_1 = require("@dialogexe/cw-http-service");
const actions_1 = require("./actions");
const cw_parameters_provider_1 = require("@dialogexe/cw-parameters-provider");
const reviewConverter_1 = require("../converters/reviewConverter");
const maxReviews = 20;
const getPartnerApi = () => {
    const partners = cw_parameters_provider_1.parametersProvider.get('site.partners');
    switch (partners[0]) {
        case 118:
            return 'api.bryneFilmgrail';
        case 178:
            return 'api.fredrikstadFilmgrail';
    }
};
const getReviews = ({ ediNumber }) => {
    const baseUrl = getPartnerApi();
    const request = new cw_http_service_1.Request(cw_parameters_provider_1.parametersProvider.get(baseUrl));
    return request
        .get('reviews', {
        ediNumber: ediNumber,
        skip: 0,
        take: maxReviews
    }, {
        withCredentials: true
    });
};
function* fetchReviews(action) {
    try {
        const reviews = yield effects_1.call(getReviews, { ediNumber: action.payload.ediNumber });
        const allReviews = reviewConverter_1.convertMultiToReviewModel(reviews.data);
        yield effects_1.put(actions_1.actionCreators.fetchReviewsSuccess(allReviews));
    }
    catch (error) {
        yield effects_1.put(actions_1.actionCreators.fetchReviewsFailed(error.response));
    }
}
exports.watchFetchReviewsAsync = effects_1.takeLatest(actions_1.actions.REQUEST_REVIEWS, fetchReviews);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/reviews/sagas.ts